import { Component } from "react";
import Select from "react-select";

import { PrimaryButton, CancelButton } from "common/components/buttons";
import { Modal } from "common/components/modal";
import { TokenField } from "./TokenField";

export class FiltersModal extends Component {
    constructor(props) {
        super(props);
        const filter = props.isSavedFilter();
        let name = "";
        if (props.initialAction === "copy" || props.initialAction === "edit") {
            name = props.initialAction === "copy" ? `${filter.name} (copy)` : filter.name;
        }
        this.state = {
            modalAction: props.initialAction,
            name,
            selectedFilter: filter
        };
    }
    
    onChangeSaveType = (saveType) => (e) => {
        this.setState({ modalAction: saveType });
    };
    
    onChangeName = (e) => {
        const name = e.currentTarget.value;
        this.setState({ name });
    };
    
    closeModal = () => {
        this.props.closeModal();
    };
    
    save = () => {
        const data = {
            name: this.state.name,
            qualifiers: this.props.qualifiers.toString()
        };
        
        if (this.state.modalAction === "edit") {
            this.props.updateFilter({ ...this.state.selectedFilter, ...data });
        } else {
            this.props.saveFilter(data);
        }
    };
    
    selectFilter = (opt, obj) => {
        const filter = this.props.filters.find((f) => f._id === opt.value);
        this.setState({ selectedFilter: filter, name: filter.name });
    };

    // TODO consider extracting the header part of this code and passing it to `<Modal /> via the `header` prop
    renderChildren = () => (
        <div className="saved-filters-modal-wrapper">
            <div className="saved-filters-modal">
                <div className="modal-body">
                    <div className="options">
                        <div>
                            <input type="radio" name="action" onChange={this.onChangeSaveType("new")} checked={this.state.modalAction === "new" || this.state.modalAction === "copy"} />
                            <div className="lbl">Save a new filter</div>
                        </div>
                        <div>
                            <input type="radio" name="action" onChange={this.onChangeSaveType("edit")} checked={this.state.modalAction === "edit"} />
                            <div className="lbl">Update an existing filter</div>
                        </div>
                    </div>
                    {this.renderInputs()}
                    <div className="tokens">
                        <div className="lbl">Filters</div>
                        <TokenField>
                            <div className="tokenfield">
                                {this.props.getTokens(null, true)}
                            </div>
                        </TokenField>
                    </div>
                </div>
            </div>
        </div>
    );
    
    renderInputs = () => {
        const opts = this.props.filters.map((f) => ({ label: f.name, value: f._id })).sort((a, b) => (a.label > b.label ? 1 : -1));
        
        if (this.state.modalAction === "new" || this.state.modalAction === "copy") {
            return (
                <div className="filter-name">
                    <div className="lbl">Name</div> <input className="form-control name-input" type="text" placeholder="Start typing a name" onChange={this.onChangeName} value={this.state.name} />
                </div>
            );
        }
        let defaultOpt = "";
        if (this.state.selectedFilter) {
            defaultOpt = opts.find((o) => o.value === this.state.selectedFilter._id);
        }
        return (
            <div className="filter-select"><div className="lbl">Filter</div> <Select className="dd" defaultValue={defaultOpt} options={opts} onChange={this.selectFilter}/></div>
        );
    };
    
    render() {
        if (!this.props.open) {
            return null;
        }
        return (
            <Modal
                actions={[
                    <CancelButton onClick={this.closeModal}>Cancel</CancelButton>,
                    <PrimaryButton onClick={this.save}>Save</PrimaryButton>
                ]}
                close={this.closeModal}
                header="Save a filter"
                portalId="modal-save-filter"
                show={this.props.open}
            >
                {this.renderChildren()}
            </Modal>
        );
    }
}
